import axios from "axios";
import constants from "../constants/constant";
import login from '../views/Pages/Login/Login';
import "react-toastify/dist/ReactToastify.css";
import toastService from "./toastnotification";
const toastservice = new toastService();
export default class HttpTransferService {
  baseUrl = constants.BASE_URL;
  tokenstring = constants.TOKEN_HEADER_STRING;
  apiEntity = constants.API_ENTITY;
  sourceCustomerEntity = constants.SOURCE_CUSTOMER_ENTITY;
  sourceCustomerAddressEntity = constants.SOURCE_CUSTOMER_ADDRESS;
  sourceCustomeEnquiry = constants.SOURCE_CUSTOMER_ENQUIRY;
  userQueryUrl = constants.USER_QUERY;
  createSourceCustomerEntity = constants.CREATE_SOURCE_COUSTOMER_ENTITY;
  createSourceCustomerEntityAddress =
    constants.CREATE_SOURCE_CUSTOMER_ENTITY_ADDRESS;
  createSourceCustomerEnquiryEntity = constants.CREATE_SOURCE_COUSTOMER_ENQUIRY;
  createUser = constants.CREATE_USER_QUERY;
  createSourceCustomerEntity = constants.CREATE_SOURCE_COUSTOMER_ENTITY;
  createSourceCustomerEntityAddress =
    constants.CREATE_SOURCE_CUSTOMER_ENTITY_ADDRESS;
  saveSourceCustomerEntityAddress =
    constants.SAVE_SOURCE_CUSTOMER_ENTITY_ADDRESS;
  updateSourceCustomerEntityAddress =
    constants.UPDATE_SOURCE_CUSTOMER_ENTITY_ADDRESS;
  fetchStateList = constants.GET_STATE_LIST;
  fetchCityList = constants.GET_CITY_LIST;
  addcity = constants.ADD_CITY;
  api = constants.API;
  action = constants.ACTION;
  userTitleQuery = constants.USER_TITLE_QUERY;
  changePassword = constants.CHANGEPASSWORD;
  query = constants.QUERY;
  refreshToken = constants.REFRESH_TOKEN;
  userAdditional = constants.USERADDITIONAL;
  refreshErrorMessage = "Unauthorized";
  entityAdditional = constants.ENTITY_ADDITIONAL;
  userImage = constants.USER_IMAGE;
  sendmail = constants.SEND_MAIL;
  notificationHistoryQuery = constants.NOTIFICATIONHISTORYQUERY;
  notificationHistory = constants.NOTIFICATIONHISTORY;
  fcmToken = constants.FCMTOKEN;
  apiUserSession = constants.SESSIONS_API_URL;
  logout = constants.LOGOUT;
  getUserEntities = constants.GET_USER_ENTITIES;
  switchToNewEntity = constants.SWITCH_TO_NEW_ENTITY;
  resendverficationmailpath = constants.RESEND_VERIFICATION_MAIL;
  fileUpload = constants.FILE_UPLOAD;
  conversationQuery = constants.CONVERSATION;
  createConversation = constants.CREATE_CONVERSATION;
  clientQuery = constants.CLIENT;
  channelQuery = constants.CHANNEL;
  conversationStatus = constants.CONVERSATION_STATUS;
  taskType = constants.TASKTYPE;
  projectQuery = constants.PROJECT;
  createProject = constants.CREATE_PROJECT;
  bucketQuery = constants.BUCKET;
  conversationStatusQuery = constants.CONVERSATION_STATUS;
  conversationTaskTypeQuery = constants.CONVERSATION_TASK_TYPE;
  employeeQuery = constants.EMPLOYEE;
  createTask = constants.CREATE_TASK;
  taskQuery = constants.TASK;
  conversationActivityQuery = constants.CONVERSATION_ACTIVITY;
  removeMedia = constants.REMOVE_MEDIA;
  filter = constants.FILTER;
  filterQuery = constants.FILTER_QUERY;
  taskActivity = constants.TASK_ACTIVITY;
  createConversationActivity = constants.CREATE_CONVERSATION_ACTIVITY;
  emailQuery = constants.EMAIL_QUERY;
  email = constants.EMAIL;
  connectedEmailQuery = constants.CONNECTED_EMAIL_QUERY;
  connectEmail = constants.CONNECT_EMAIL;
  createClient = constants.CREATE_CLIENT;
  createEmployee = constants.CREATE_EMPLOYEE;
  clientActivity = constants.CLIENT_ACTIVITY;
  emailConnection = constants.EMAIL_CONNECTION;

  getRefreshToken(inputjson) {
    var url = this.baseUrl + this.api + this.refreshToken;
    return this.postCall(inputjson, url);
  }

  passwordChange(inputjosn, entity_id, user_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.createUser +
      "/" +
      user_id +
      this.changePassword;
    return this.putCall(inputjosn, url);
  }

  updateInfo(inputjosn, entity_id, user_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.createUser +
      "/" +
      user_id;
    return this.putCall(inputjosn, url);
  }

  queryUserImage(inputjosn, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + this.userImage;
    return this.postCall(inputjosn, url);
  }

  userQuery(inputjson, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + this.userQueryUrl;
    return this.postCall(inputjson, url);
  }

  sourceCustomerAddress(inputjson, entity_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.sourceCustomerAddressEntity;
    return this.postCall(inputjson, url);
  }

  getSourceCustomerEntity(inputjson) {
    var url = this.baseUrl + this.sourceCustomerEntity;
    return this.postCall(inputjson, url);
  }

  getUserQuery(inputjson, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + "/user/query";
    return this.postCall(inputjson, url);
  }
  createUserQuery(inputjson, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + this.createUser;
    return this.postCall(inputjson, url);
  }

  updateUserQuery(inputjson, entity_id) {
    var url =
      this.baseUrl + this.apiEntity + entity_id + "/user/" + inputjson.user_id;
    return this.putCall(inputjson, url);
  }

  deleteUser(entity_id, user_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + "/user/" + user_id;
    return this.deleteCall({}, url);
  }

  addSourceCustomerEntity(inputjson) {
    var url = this.baseUrl + this.createSourceCustomerEntity;
    return this.postCall(inputjson, url);
  }
  updateSourceCustomerEntity(inputjson, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id;
    return this.putCall(inputjson, url);
  }

  displaySourceCustomerAddress(inputjson, entity_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.createSourceCustomerEntityAddress;
    return this.postCall(inputjson, url);
  }

  saveSourceCustomerAddress(inputjson, entity_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.saveSourceCustomerEntityAddress;
    return this.postCall(inputjson, url);
  }

  updateSourceCustomerAddress(inputjson, entity_id, address_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.updateSourceCustomerEntityAddress +
      address_id;
    return this.putCall(inputjson, url);
  }

  deleteSourceCustomerAddress(entity_id, address_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.updateSourceCustomerEntityAddress +
      address_id;
    return this.deleteCall({}, url);
  }

  getStateList() {
    var url = this.baseUrl + this.fetchStateList;
    return this.postCall({}, url);
  }

  getCityList(inputjson) {
    var url = this.baseUrl + this.fetchCityList;
    return this.postCall(inputjson, url);
  }

  getUserTitle(entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + this.userTitleQuery;
    return this.getCall(url);
  }

  getConversationList(inputjson) {
    var url = this.baseUrl + this.api + this.conversationQuery;
    return this.postCall(inputjson, url);
  }

  createNewConversation(inputjson) {
    var url = this.baseUrl + this.api + this.createConversation;
    return this.postCall(inputjson, url);
  }

  updateConversation(inputjson, conversationId) {
    var url = this.baseUrl + this.api + "conversation/" + conversationId;
    return this.putCall(inputjson, url);
  }

  updateConversationActivity(
    inputjson,
    conversationId,
    conversationActivityId
  ) {
    var url =
      this.baseUrl +
      this.api +
      "conversation/" +
      conversationId +
      "/conversationactivity/" +
      conversationActivityId;
    return this.putCall(inputjson, url);
  }

  getClientList(inputjson) {
    var url = this.baseUrl + this.api + this.clientQuery;
    return this.postCall(inputjson, url);
  }

  generateMqttKey(inputjson) {
    var url = this.baseUrl + this.api + this.channelQuery;
    return this.postCall(inputjson, url);
  }

  taskTypeQuery(inputjson) {
    var url = this.baseUrl + this.api + this.taskType;
    return this.postCall(inputjson, url);
  }

  getProjectList(inputjson) {
    var url = this.baseUrl + this.api + this.projectQuery;
    return this.postCall(inputjson, url);
  }

  createNewProject(inputjson) {
    var url = this.baseUrl + this.api + this.createProject;
    return this.postCall(inputjson, url);
  }

  updateProject(inputjson, project_id) {
    var url = this.baseUrl + this.api + this.createProject + "/" + project_id;
    return this.putCall(inputjson, url);
  }

  deleteProject(inputjson, project_id) {
    var url = this.baseUrl + this.api + this.createProject + "/" + project_id;
    return this.deleteCall(inputjson, url);
  }

  getBucketList(inputjson) {
    var url = this.baseUrl + this.api + this.bucketQuery;
    return this.postCall(inputjson, url);
  }

  getConversationStatusList(inputjson) {
    var url = this.baseUrl + this.api + this.conversationStatusQuery;
    return this.postCall(inputjson, url);
  }

  getConversationTaskTypeList(inputjson) {
    var url = this.baseUrl + this.api + this.conversationTaskTypeQuery;
    return this.postCall(inputjson, url);
  }

  getEmployees(inputjson) {
    var url = this.baseUrl + this.api + this.employeeQuery;
    return this.postCall(inputjson, url);
  }

  createNewTask(inputjson) {
    var url = this.baseUrl + this.api + this.createTask;
    return this.postCall(inputjson, url);
  }

  queryTask(inputjson) {
    var url = this.baseUrl + this.api + this.taskQuery;
    return this.postCall(inputjson, url);
  }

  updateTask(inputjson, task_id) {
    var url = this.baseUrl + this.api + this.createTask + "/" + task_id;
    return this.putCall(inputjson, url);
  }

  deleteTask(inputjson, task_id) {
    var url = this.baseUrl + this.api + this.createTask + "/" + task_id;
    return this.deleteCall(inputjson, url);
  }

  getConversationActivities(inputjson) {
    var url = this.baseUrl + this.api + this.conversationActivityQuery;
    return this.postCall(inputjson, url);
  }

  removeMediaPath(inputjson, url) {
    var url = this.baseUrl + this.api + this.removeMedia;
    return this.postCall(inputjson, url);
  }

  saveFilter(inputjson) {
    var url = this.baseUrl + this.api + this.filter;
    return this.putCall(inputjson, url);
  }

  queryFilter(inputjson) {
    var url = this.baseUrl + this.api + this.filterQuery;
    return this.postCall(inputjson, url);
  }

  queryTaskActivity(inputjson) {
    var url = this.baseUrl + this.api + this.taskActivity;
    return this.postCall(inputjson, url);
  }

  queryClientActivity(inputjson) {
    var url = this.baseUrl + this.api + this.clientActivity;
    return this.postCall(inputjson, url);
  }

  addTaskComment(inputjson, taskId) {
    var url =
      this.baseUrl + this.api + this.createTask + "/" + taskId + "/activity";
    return this.postCall(inputjson, url);
  }

  createNewConversationActivity(inputjson, conversationId) {
    var url =
      this.baseUrl +
      this.api +
      this.createConversationActivity +
      conversationId +
      "/conversationactivity";
    return this.postCall(inputjson, url);
  }

  getConversationEmail(inputjson) {
    var url = this.baseUrl + this.api + this.emailQuery;
    return this.postCall(inputjson, url);
  }

  queryConnectedEmail(inputjson) {
    var url = this.baseUrl + this.api + this.email + this.connectedEmailQuery;
    return this.postCall(inputjson, url);
  }

  emailConnect(inputjson) {
    var url = this.baseUrl + this.api + this.email + this.connectEmail;
    return this.postCall(inputjson, url);
  }

  createNewClient(inputjson) {
    var url = this.baseUrl + this.api + this.createClient;
    return this.postCall(inputjson, url);
  }

  createNewEmplyoee(inputjson, clientId) {
    var url =
      this.baseUrl +
      this.api +
      this.createClient +
      "/" +
      clientId +
      "/employee";
    return this.postCall(inputjson, url);
  }

  deleteEmplyoee(inputJson, clientId, employeeId) {
    var url =
      this.baseUrl +
      this.api +
      this.createClient +
      "/" +
      clientId +
      "/employee/" +
      employeeId;
    return this.deleteCall(inputJson, url);
  }

  deleteClient(inputJson, clientId) {
    var url = this.baseUrl + this.api + this.createClient + "/" + clientId;
    return this.deleteCall(inputJson, url);
  }

  updateClient(inputjson, clientId) {
    var url = this.baseUrl + this.api + this.createClient + "/" + clientId;
    return this.putCall(inputjson, url);
  }

  updateEmployee(inputjson, clientId, employeeId) {
    var url =
      this.baseUrl +
      this.api +
      this.createClient +
      "/" +
      clientId +
      "/employee/" +
      employeeId;
    return this.putCall(inputjson, url);
  }

  deleteEmailConnection(inputjson, connectionId) {
    var url = this.baseUrl + this.api + this.emailConnection + connectionId;
    return this.deleteCall(inputjson, url);
  }

  setRefreshToken() {
    let userInfo = localStorage.getItem("user_info");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);

      var params = {
        client_id: localStorage.getItem("client_id"),
        user_id: userInfo.user_id,
        server_unique_id: localStorage.getItem("serveruniqueid"),
      };
      return this.getRefreshToken(params).then((response) => {
        if (response.status === 200) {
          let loginObject = new login();
          loginObject.setUserInfoInLocalStorage(response);
          localStorage.setItem(
            "refreshtoken",
            response["headers"]["refresh-token"]
          );
          return true;
        } else {
          return false;
        }
      });
    }
  }
  updateUserAdditionalAttributes(inputjson, entity_id, user_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.createUser +
      "/" +
      user_id +
      this.userAdditional;
    return this.postCall(inputjson, url);
  }
  queryUserAdditionalAttributes(inputjson, entity_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      "/" +
      this.userAdditional +
      this.query;
    return this.postCall(inputjson, url);
  }
  updateEntityAdditionalAttributes(inputjson, entity_id) {
    var url =
      this.baseUrl + this.apiEntity + entity_id + "/" + this.entityAdditional;
    return this.postCall(inputjson, url);
  }
  queryEntityAdditionalAttributes(inputjson) {
    var url = this.baseUrl + this.api + this.entityAdditional + this.query;
    return this.postCall(inputjson, url);
  }
  sendEmail(inputjson) {
    let url = this.baseUrl + this.api + this.sendmail;
    return this.postCall(inputjson, url);
  }
  enqueryNotification(inputjosn, entity_id) {
    var url =
      this.baseUrl + this.apiEntity + entity_id + this.notificationHistoryQuery;
    return this.postCall(inputjosn, url);
  }

  readNotification(inputjson, entity_id, user_id) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      this.createUser +
      "/" +
      user_id +
      this.notificationHistory;
    return this.putCall(inputjson, url);
  }

  logoutSession() {
    let inputjosn = {
      user_id: constants.USER_ID,
      client_id: constants.CLIENT_ID,
    };
    var url = this.baseUrl + this.apiUserSession + this.logout;
    return this.postCall(inputjosn, url);
  }

  getEntities(inputjosn, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + this.getUserEntities;
    return this.postCall(inputjosn, url);
  }

  setNewEntity(inputjosn, entity_id) {
    var url =
      this.baseUrl + this.apiEntity + entity_id + this.switchToNewEntity;
    return this.postCall(inputjosn, url);
  }
  changePasswordRequest(inputjson, type) {
    var entity_id = localStorage.getItem("entity_id");
    var user_id = JSON.parse(localStorage.getItem("user_info")).user_id;
    var url =
      this.baseUrl + "api/entity/" + entity_id + /user/ + user_id + "/" + type;
    if (type === "emailchange" || type === "changemobile") {
      return this.postCall(inputjson, url);
    } else {
      return this.putCall(inputjson, url);
    }
  }

  verifyOTPQuery(inputjson) {
    var entity_id = localStorage.getItem("entity_id");
    var user_id = JSON.parse(localStorage.getItem("user_info")).user_id;
    var url =
      this.baseUrl +
      "api/entity/" +
      entity_id +
      /user/ +
      user_id +
      "/verifyandresendotp";
    return this.postCall(inputjson, url);
  }

  logoutQuery(inputjson) {
    var entity_id = localStorage.getItem("entity_id");
    var url = this.baseUrl + "api/entity/" + entity_id + "/logoutdevices";
    return this.postCall(inputjson, url);
  }

  getLoginDevicesInfo(inputjson) {
    var entity_id = localStorage.getItem("entity_id");
    var url = this.baseUrl + "api/entity/" + entity_id + "/logindevices/query";
    return this.postCall(inputjson, url);
  }

  generateTokenForLinking() {
    var inputjson = {};
    var entity_id = localStorage.getItem("entity_id");
    var url = this.baseUrl + "api/entity/" + entity_id + "/generatetoken";
    return this.postCall(inputjson, url);
  }

  resendVerificationMailRequest(userId) {
    var url = this.baseUrl + this.api + this.resendverficationmailpath + userId;
    return this.getCall(url);
  }

  uploadFileOnServer(inputjson, entity_id) {
    var url = this.baseUrl + this.apiEntity + entity_id + this.fileUpload;
    return this.postCall(inputjson, url);
  }

  uploadImage(inputjson, entity_id, userId) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      "/user/" +
      userId +
      "/userimage";
    return this.postCall(inputjson, url);
  }

  deleteImage(entity_id, userId, imageId) {
    var url =
      this.baseUrl +
      this.apiEntity +
      entity_id +
      "/user/" +
      userId +
      "/image/" +
      imageId;
    return this.deleteCall({}, url);
  }

  uploadFileOnAws(file, url) {
    return this.putCallForFile(file, url);
  }

  postCall(inputjson, url) {
    var accesstoken = localStorage.getItem("token");
    var self = this;
    return axios
      .request({
        url: url,
        method: "post",
        data: inputjson,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": accesstoken,
          "refresh-token": localStorage.getItem("refreshtoken"),
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error.response);
        if (
          error.response.status === 401 &&
          error.response.data.message === self.refreshErrorMessage
        ) {
          return self.setRefreshToken().then((response) => {
            if (response) {
              return self.postCall(inputjson, url);
            } else if (error.response.status === 422) {
              localStorage.removeItem("entity_id");
              localStorage.removeItem("user_info");
              localStorage.removeItem("client_id");
              window.location.href = "/login";
              return false;
            }
          });
        } else if (error.response.status === 422) {
          localStorage.removeItem("entity_id");
          localStorage.removeItem("user_info");
          localStorage.removeItem("client_id");
          window.location.href = "/login";
          return false;
        }
        toastservice.error(error.response.data.message);
        return error.response.data;
      });
  }

  putCall(inputjson, url) {
    var accesstoken = localStorage.getItem("token");
    var self = this;
    return axios
      .request({
        url: url,
        method: "put",
        data: inputjson,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": accesstoken,
          "refresh-token": localStorage.getItem("refreshtoken"),
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (
          error.response.status === 401 &&
          error.response.data.message === self.refreshErrorMessage
        ) {
          return self.setRefreshToken().then((response) => {
            if (response) {
              return self.putCall(inputjson, url);
            }
          });
        }
        toastservice.error(error.response.data.message);
        return error.response.data;
      });
  }

  deleteCall(inputjson, url) {
    var self = this;
    var accesstoken = localStorage.getItem("token");
    return axios
      .request({
        url: url,
        method: "delete",
        data: inputjson,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": accesstoken,
          "refresh-token": localStorage.getItem("refreshtoken"),
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (
          error.response.status === 401 &&
          error.response.data.message === self.refreshErrorMessage
        ) {
          return self.setRefreshToken().then((response) => {
            if (response) {
              return self.deleteCall(inputjson, url);
            }
          });
        }
        toastservice.error(error.response.data.message);
        return error.response.data;
      });
  }

  getCall(url) {
    var self = this;
    var accesstoken = localStorage.getItem("token");
    return axios({
      method: "get",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-token": accesstoken,
        "refresh-token": localStorage.getItem("refreshtoken"),
      },
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (
          error.response.status === 401 &&
          error.response.data.message === self.refreshErrorMessage
        ) {
          return self.setRefreshToken().then((response) => {
            if (response) {
              return self.getCall(url);
            }
          });
        }
        return error.response.data;
      });
  }

  putCallForFile(inputjson, url) {
    var accesstoken = localStorage.getItem("token");
    var self = this;
    return axios
      .request({
        url: url,
        method: "put",
        data: inputjson,
        headers: {
          "Content-Type": "application/octet-stream",
          Accept: "image/*,application/pdf",
          "x-auth-token": accesstoken,
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (
          error.response.status === 401 &&
          error.response.data.message === self.refreshErrorMessage
        ) {
          return self.setRefreshToken().then((response) => {
            if (response) {
              return self.putCall(inputjson, url);
            }
          });
        }
        toastservice.error(error.response.data.message);
        return error.response.data;
      });
  }

  getAnalyticsSummary(inputjson) {
    var url = this.baseUrl + this.api + "item/summary";
    return this.postCall(inputjson, url);
  }

  getSecondaryDashboard(){
    var url = this.baseUrl + this.api + constants.SECONDARY_DASHBOARD_API;
    return this.postCall({},url);
  }
  deleteConversation(conversationId){
    var url = this.baseUrl + this.api + "conversation/" + conversationId;
    console.log("delete conversation url", url);
    return this.deleteCall({}, url);
  }
  completeConversation(conversationId){
    var url = this.baseUrl + this.api + "conversation/completed/" + conversationId;
    console.log("complete conversation url", url);
    return this.postCall({}, url);
  }
}
